module.exports = __webpack_public_path__ + "static/img/gkdfl@2x.91cb387.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/gkdfl@2x.png
// module id = adC8
// module chunks = 1